<template>
  <div class="error">
      <h2>Something went wrong please try again later.</h2>
  </div>
</template>

<script>
export default {

}
</script>

<style>
.error {
    color: red;
    font-style: bold;
}
</style>